<script>
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
export default {
	mixins: [checkoutMixin],
	data() {
		return { btnStatus: 'default', redirecting: false, comment: '' }
	},
	methods: {
		async submit() {
			this.btnStatus = 'loading'
			let response = await this.checkout.stepSubmit({ comment: this.comment })
			const orderId = response.data?.stepResponse?.orderId
			if (orderId) {
				this.redirectAfterPurchase(response.data?.stepResponse)
				this.redirecting = true
			} else {
				this.btnStatus = 'error'
			}
		},
	},
}
</script>
<template>
	<div>
		<v-textarea
			v-if="$srv('simpleOrder')"
			label="Deja un comentario para tu pedido (opcional)"
			outlined
			v-model="comment"
		/>
		<div>
			<b> Confirma tu pedido para avanzar </b>
		</div>
		<div class="d-flex justify-center justify-sm-end pt-6">
			<IndeterminateProgressBtn
				v-model="btnStatus"
				default-color="cta"
				success-color="success"
				error-color="error"
				@click="submit()"
				:error-duration="5000"
				block
			>
				Confirmar Pedido
				<template #loading>
					{{ redirecting ? 'Ya casi terminamos...' : 'Generando tu Orden de Compra...' }}
				</template>
				<template #success>
					<div></div>
				</template>
				<template #error>
					<v-icon left> mdi-close-thick </v-icon>
					Lo sentimos, ha ocurrido un error
				</template>
			</IndeterminateProgressBtn>
		</div>
	</div>
</template>

<style></style>

